import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';
import { PlannerFacade } from './planner.facade';


@Injectable()
export class PlannerActions {
    static FETCH_ORIGIN_LIST = '[Schedule]: Fetch planner origin list';
    static FETCH_ORIGIN_LIST_SUCCESS = '[Schedule]: Fetch planner origin list success';
    static FETCH_ORIGIN_LIST_FAIL = '[Schedule]: Fetch planner origin list fail';

    static FETCH_DESTINATION_LIST = '[Schedule]: Fetch planner destination list';
    static FETCH_DESTINATION_LIST_SUCCESS = '[Schedule]: Fetch planner destination list success';
    static FETCH_DESTINATION_LIST_FAIL = '[Schedule]: Fetch planner destination list fail';

    static SET_ORIGIN = '[Schedule]: Set planner origin';
    static SET_DESTINATION = '[Schedule]: Set planner destination';

    static FETCH_TRIP = '[Schedule]: Fetch trip';
    static FETCH_TRIP_SUCCESS = '[Schedule]: Fetch trip success';
    static FETCH_TRIP_FAIL = '[Schedule]: Fetch trip fail';
    static RESET_TRIPS = '[Schedule]: Reset trips';

    static SET_SELECTED_TRIP_ID = '[Schedule]: Set selected trip id';

    static SET_SELECTED_DATE = '[Schedule]: Set selected date';

    static SET_SELECTED_PRIORITY = '[Schedule]: Set selected priority';
    static RESET_PLANNER = '[Schedule] Reset planner';

    fetchOriginList(stopName): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_ORIGIN_LIST,
            payload: stopName,
        };
    }

    fetchOriginListSuccess(payload): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_ORIGIN_LIST_SUCCESS,
            payload: payload,
        };
    }

    fetchOriginListFail(): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_ORIGIN_LIST_FAIL,
        };
    }

    setOrigin(payload): RidangoReduxAction {
        return {
            type: PlannerActions.SET_ORIGIN,
            payload: payload
        };
    }

    fetchDestinationList(payload): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_DESTINATION_LIST,
            payload: payload
        };
    }

    fetchDestinationListSuccess(payload): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_DESTINATION_LIST_SUCCESS,
            payload: payload,
        };
    }

    fetchDestinationListFail(): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_DESTINATION_LIST_FAIL,
        };
    }

    setDestination(payload): RidangoReduxAction {
        return {
            type: PlannerActions.SET_DESTINATION,
            payload: payload
        };
    }

    fetchTrip(payload): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_TRIP,
            payload: payload
        };
    }

    fetchTripSuccess(payload): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_TRIP_SUCCESS,
            payload: payload
        };
    }

    fetchTripFail(): RidangoReduxAction {
        return {
            type: PlannerActions.FETCH_TRIP_FAIL,
        };
    }

    setSelectedTripId(payload): RidangoReduxAction {
        return {
            type: PlannerActions.SET_SELECTED_TRIP_ID,
            payload: payload
        };
    }

    setDate(date: Date): RidangoReduxAction {
        return {
            type: PlannerActions.SET_SELECTED_DATE,
            payload: date
        };
    }

    setPriority(priority: number): RidangoReduxAction {
        return {
            type: PlannerActions.SET_SELECTED_PRIORITY,
            payload: priority
        };
    }

    resetTrips(): RidangoReduxAction {
        return {
            type: PlannerActions.RESET_TRIPS,
        };
    }

    resetPlanner(): RidangoReduxAction {
        return {
            type: PlannerActions.RESET_PLANNER,
        };
    }
}
